import {INotificationWrapperInterfacesMap} from '@toolify/client/src/modules/notifications/types/INotificationWrapperInterfacesMap'
import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'
import {NotificationWrapperType} from '../types/NotificationWapperType'

type IPayloadGenerator<T extends ConversationType> = (
  payload: IConversationTypeInterfacesMap[T]['notificationPayload']
) => INotificationWrapperInterfacesMap[NotificationWrapperType.DatabaseItem]['payload'] | null

export const GetMessageNotificationWrapperPayloadByConversationTypeMap = new Map<ConversationType, IPayloadGenerator<ConversationType>>([
  [ConversationType.Workspace, () => null],
  [ConversationType.CloudFile, () => null],
  [ConversationType.DatabaseCell, (payload) => {
    const typedPayload = payload as IConversationTypeInterfacesMap[ConversationType.DatabaseCell]['notificationPayload']
    return {
      databaseId: typedPayload.databaseId,
      databaseItemId: typedPayload.databaseItemId,
      workspaceName: typedPayload.workspaceName,
    }
  }],
  [ConversationType.DatabaseFile, (payload) => {
    const typedPayload = payload as IConversationTypeInterfacesMap[ConversationType.DatabaseFile]['notificationPayload']
    return {
      databaseId: typedPayload.databaseId,
      databaseItemId: typedPayload.databaseItemId,
    }
  }],
])
